import Mailbox from './mailbox';

export type AuthenticatedMailbox = Mailbox & {
  credential: NonNullable<Mailbox['credential']>;
};

export function isAuthenticatedMailbox(mailbox: Mailbox): mailbox is AuthenticatedMailbox {
  return !!mailbox.credential;
}
